import PropTypes, { InferProps } from 'prop-types'
import { Card, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'

const bannerWrapperProps = {
  /** Optional (String) background color for the banner */
  bgColor: PropTypes.string,
  /** Optional (String) color of a thick "hug" border at the top of the banner */
  borderHugTop: PropTypes.string,
  /** Optional (String) color of a thick "hug" border at the left side of the banner */
  borderHugLeft: PropTypes.string,
  /** Optional (String) color of a 1px border around the entire banner */
  outline: PropTypes.string,
  /** Optional (string) preconfigured style option */
  variation: PropTypes.string,
}

type bannerWrapperType = InferProps<typeof bannerWrapperProps>

const BannerWrapper = styled(Card)<bannerWrapperType>`
  ${(props) => `
    position: relative;
    background-color: ${getPaletteColor(props.bgColor)(props)};
    ${props.outline ? `border-color: ${getPaletteColor(props.outline)(props)}` : 'border-width: 0px'};
    ${
      props.borderHugLeft &&
      `border-left-width: 6px; border-left-color: ${getPaletteColor(props.borderHugLeft)(props)};`
    }
    ${
      props.borderHugTop &&
      `border-top-width: 6px; border-top-color: ${getPaletteColor(props.borderHugTop)(props)};`
    };
  `};
`

BannerWrapper.defaultProps = {
  bgColor: 'background.lightest',
  outline: '',
  borderHugTop: '',
  borderHugLeft: '',
}

export default BannerWrapper
